// extracted by mini-css-extract-plugin
export var imageSection = "bM_bf";
export var loanCard = "bM_f3";
export var textSection = "bM_bg";